import { OktaAuth } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import {
  AUTH_TOKEN_KEY,
  LOGIN_CALLBACK_PATHNAME,
  LOGIN_PATHNAME,
} from "core/constants";

const REDIRECT_URI = `${window.location.origin}${LOGIN_CALLBACK_PATHNAME}`;

export const isOktaEnabled =
  localStorage.getItem("oktaEnabled") || USE_OKTA === "true";

export const oktaAuthConfig = {
  clientId: OKTA_CLIENT_ID,
  issuer: OKTA_ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ["openid", "profile", "email"],
  pkce: true,
};

/* UTILS: */

// https://github.com/okta/okta-auth-js#restoreoriginaluri
// For some reason Typescript is barking at us that we must supply a function to Security...
// Even tho the docs specify: "by default it uses window.location.replace to redirect back to the originalUri."
// TLDR this function is to satisfy the Linter. ¯\_(ツ)_/¯
export const restoreOriginalUri = async (
  _oktaAuth: OktaAuth,
  originalUri: string,
) => {
  window.location.replace(originalUri);
};

// As we move away from a local Auth, abstracting a bit is a good thang.
export const removeAccessToken = () => {
  if (!isOktaEnabled) localStorage.removeItem(AUTH_TOKEN_KEY);
};

// OKTA TODO: Use `useHistory`?
export const redirectToLogin = () => {
  if (!isOktaEnabled) window.location.replace(LOGIN_PATHNAME);
};

export const removeAccessTokenAndRedirectToLogin = () => {
  removeAccessToken();
  redirectToLogin();
};

/* HOOKS */
export const useGetAccessToken = () => {
  const { authState } = useOktaAuth() || {};
  if (!isOktaEnabled) return localStorage.getItem(AUTH_TOKEN_KEY);

  return authState && authState.accessToken?.accessToken;
};

export const useLogout = () => {
  const { oktaAuth } = useOktaAuth() || {};
  const logout = async () => {
    if (isOktaEnabled)
      await oktaAuth.signOut().then(() => {
        // Clear Central Auth, keep in sync with:
        // https://github.com/Flatbook/identity/blob/main/internal/http/static/logout.html#L10-L22
        window.location.replace(
          `
            https://sonder.okta.com/login/signout?fromURI=
            https://sonder-vendors.okta.com/login/signout?fromURI=
            https://sonder-fed.okta.com/login/signout?fromURI=
            ${window.location.href}
          `,
        );
      });
  };
  return { logout };
};

export const useHandleAuthenticationError = () => {
  const { logout } = useLogout();

  const handleAuthenticationError = () => {
    // This is a NOOP if OKTA is enabled.
    removeAccessTokenAndRedirectToLogin();
    // This is a NOOP if OKTA is not enabled.
    logout();
  };

  return { handleAuthenticationError };
};
